// Visar rätt färgbild i galleriet när kunden väljer färg i paketväljaren.
(function () {
  var mediaByVariant = {};

  fetch(window.location.pathname.split('?')[0] + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      product.variants.forEach(function (v) {
        if (v.featured_media) mediaByVariant[v.id] = v.featured_media.id;
      });
    })
    .catch(function () {});

  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select || select.tagName !== 'SELECT') return;
    var mediaId = mediaByVariant[select.value];
    if (!mediaId) return;
    var item = document.querySelector('[data-media-id$="-' + mediaId + '"]');
    if (!item) return;
    var gallery = item.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    // Samma beteende som temats egen färgväljare: lägg bilden först och visa den.
    gallery.setActiveMedia(item.getAttribute('data-media-id'), true);
    setTimeout(function () {
      if (item.parentElement) item.parentElement.scrollTo({ left: 0, behavior: 'instant' });
    }, 500);
  });
})();
